import React, { useState } from 'react';
import Select from 'react-select';
import { translate } from '../translations/translations.js';
import { translateCity } from '../translations/cityTranslations.js';
import loadingGif from '../assets/loading3.gif';

const SelectCitiesForm = ({ formData, cities, language, onNavigate }) => {
  const [selectedCities, setSelectedCities] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const cityOptions = cities.map(city => ({
    value: city.city_id,
    name: city.city_name,
    label: translateCity(city.city_name, language).replace(/\(.*?\)/g, ''),
  }));

  const handleCityChange = (selectedOptions) => {
    setSelectedCities(selectedOptions || []); 
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
  
    const newData = {
      ...formData,
      cities: selectedCities,
    };
  
    try {
      await onNavigate(newData); 
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isSubmitting) {
    return (
      <div className="loading-spinner">
        <img src={loadingGif} />
        <p>Loading</p>
      </div>
    );
  }

  return (
      <form onSubmit={handleSubmit}>
        <header className='form-header'>
          <h1>{translate('selectCitiesPrompt', language)}</h1>
        </header>
        <div className="form-container">
          <Select
            options={cityOptions}
            isMulti
            value={selectedCities}
            onChange={handleCityChange}
            className="react-select-container"
            classNamePrefix="react-select"
            placeholder={translate('selectCitiesPlaceholder', language)}
          />
        </div>
        <button type="submit">{translate('submit', language)}</button>
      </form>
  );
};

export default SelectCitiesForm;
